import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 保加利亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Всички права запазени',
    },
    auth: {
        login: 'Вход',
        username: 'Потребителско име',
        username_placeholder: 'Моля, въведете потребителско име',
        password: 'Парола',
        password_placeholder: 'Моля, въведете парола',
        code: 'Капча код',
        code_placeholder: 'Моля, въведете капча код',
        logout: 'Изход',
        logout_success: 'Успешен изход',
        day: 'ден',
        password_expiration: 'Паролата Ви е изтекла – моля, я сменете',
        expire: 'Остават',
        conseils:
            'Трябва да съдържа главни и малки латински букви, цифри и специални символи ({msg}). Дължината на паролата трябва да е между 8 и 16 знака.',
        brand_Selection: 'Избор на марка',
        unread_notices: 'Непрочетени съобщения',
        new_cases: 'Нови случаи',
        unanswered_cases: 'Неполучили отговор случаи',
        overdue_cases: 'Просрочени случаи',
    },
    button: {
        query: 'Запитване',
        editing_position: 'Редактиране на длъжност',
        show_theme_editor: 'Показване/Скриване на редактора за теми',
        change_password: 'Промяна на парола',
        old_password: 'Стара парола',
        new_password: 'Нова парола',
        confirm_password: 'Потвърдете паролата',
        button: 'Бутон',
        about: 'Относно',
        back: 'Назад',
        go: 'Потвърди',
        home: 'Начало',
        confirm: 'Потвърди',
        modify: 'Промени',
        edit: 'Редактирай',
        new: 'Нов',
        cancel: 'Отказ',
        close: 'Затвори',
        search: 'Търсене',
        reset: 'Нулиране',
        delete: 'Изтрий',
        add: 'Добави',
        collapse: 'Скрий',
        expand: 'Разгъни',
        download_template: 'Изтегли шаблон',
        batch_import: 'Масов импорт',
        import: 'Импортиране',
        export: 'Експортиране',
        export_fail: 'Неуспешен импорт',
        detailed: 'Подробности',
        details: 'Детайли',
        download: 'Изтегли',
        toView: 'Преглед',
        toViews: 'Преглед на изображения',
        uploadAttachments: 'Качване на прикачени файлове',
        selectFile: 'Изберете файл',
        fillingInstructions: 'Инструкции за попълване',
        release: 'Публикуване',
        release_recall: 'Отмяна на публикация',
        save: 'Запази',
        send: 'Изпрати',
        tips: 'Съвет',
        send_back: 'Върни',
        examine: 'Одобрение',
        void: 'Анулиране',
        more: 'Повече',
        refresh: 'Опресни',
        selects: 'Моля, изберете',
        serial_number: 'Пореден номер',
        upload_progress: 'Напредък на качването',
        invalid: 'Анулирано',
        daily_record: 'Дневник',
        operation_type: 'Тип операция',
        field_name: 'Име на поле',
        edit_role: 'Редактиране на роля',
        user_role: 'Изберете роля',
        assignment_role: 'Роля',
        post: 'Длъжност',
        sending: 'Изпращане...',
        reset_password: 'Нулиране на парола',
        display_or_not: 'Показване или не',
        document: 'Документ',
        specificTemplates: 'Специфични шаблони',
        transferOrder: 'Прехвърляне на поръчка',
        forwarding: 'Препращане',
        one_click_notification: 'Еднократно известяване',
        english_export: 'Експорт на английски',
        oneclick_download: 'Еднократно изтегляне',
        passwordmsga:
            'Трябва да съдържа главни и малки латински букви, цифри и специални символи (@\\$!_~\\&*)',
        passwordmsgb: 'Дължината на паролата трябва да е между 8 и 16 знака',
        passwordmsgc: 'Не трябва да съвпада с последните шест пароли',
        export_file_list: 'Списък на експортирани файлове',
        personal_center: 'Личен център',
        upload_list: 'Списък за качване',
        clear_completed: 'Изчисти завършените',
    },
    radio: {
        enabled: 'Активирано',
        disabled: 'Деактивирано',
        catalogue: 'Каталог',
        individual: 'Индивидуално',
        all: 'Всички',
        yes: 'Да',
        no: 'Не',
    },
    dropdown: {
        close_others: 'Затваряне на останалите',
        close_right: 'Затваряне на дясната страна',
        close_left: 'Затваряне на лявата страна',
    },
    table: {
        action: 'Действие',
        explain: 'Обяснение',
        fileName: 'Име на прикачения файл',
        size: 'Размер (MB)',
        uploader: 'Качил',
        uploadTime: 'Време на качване',
        system: 'Система',
        caption: 'Заглавие',
        categorization: 'Категоризация',
        link: 'Връзка',
        forwarding_time: 'Време на препращане',
        forwarder: 'Препратил',
        send_to: 'Изпратено до',
        mode: 'Режим',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / Страница`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Общо ${named('number')} записа`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Общо ${named('number')} превозни средства`,
    },
    confirm: {
        confirm_deletion: 'Потвърждаване на изтриването?',
        confirm_void: 'Потвърждаване на анулирането?',
        confirm_release: 'Потвърждаване на публикуването?',
        ack: 'Потвърди',
        cancel: 'Отказ',
        non_records: 'Моля, изберете поне един запис',
    },
    request: {
        failed_placeholder: 'Заявката неуспешна – грешка от сървъра',
        success_placeholder: 'Заявката е успешна',
        auth: {
            login_success: 'Успешен вход',
        },
        error: {
            '404': 'Пътят не съществува',
            '403': 'Недостатъчни права',
        },
    },
    page: {
        global: {
            page_search: 'Търсене в страницата',
        },
        error: {
            not_found: 'Страницата не е намерена',
            not_found_des: 'Няма нищо тук',
            auth_failed: 'Недостатъчни права',
            auth_failed_des: 'Достъпът до тази страница е забранен',
            file_format_error: 'Невалиден формат на файла!',
            preview_failed: 'Неуспешен преглед! Файлът е повреден!',
        },
        homepage: {
            homepage: homepage.homepage.bgBG, // Заменете с реалния обект, ако съществува
        },
        system: {
            menu: system.menu.bgBG,
            dict: system.dict.bgBG,
            dept: system.dept.bgBG,
            role: system.role.bgBG,
            user: system.user.bgBG,
        },
        info: {
            announcement: Info.announcement.announcement.bgBG,
            document: Info.document.document.bgBG,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.bgBG,
                recallActivity: tech.quality.recallActivity.bgBG,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.bgBG,
            },
            management: {
                inquiryOd: tech.management.inquiry.bgBG,
                permission: tech.management.permission.bgBG,
                onSiteSupportHq: tech.management.onSiteSupport.bgBG,
                progHistoryHq: tech.management.progHistory.bgBG,
                salesRecordHq: tech.management.salesRecord.bgBG,
                vehicleInfoHq: tech.management.vehicleInfo.bgBG,
                claimHq: tech.management.claim.bgBG,
                filterHq: tech.management.filter.bgBG,
                newCarlssue: tech.management.newCarIssue.bgBG,
                newCarDefinition: tech.management.newCarDefinition.bgBG,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.bgBG,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.bgBG,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.bgBG,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.bgBG,
        },
        statistics: statistics.inquiryStatistics.bgBG,
        systemClassifyA: statistics.systemClassifyA.bgBG,
        systemClassifyB: statistics.systemClassifyB.bgBG,
        engineerStatistics: statistics.engineerStatistics.bgBG,
        defectivePart: statistics.defectivePart.bgBG,
        replyInquiryStatistics: statistics.replyInquiryStatistics.bgBG,
        passRateStatistics: statistics.passRateStatistics.bgBG,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.bgBG,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.bgBG,
        customsClearance135Rate: statistics.customsClearance135Rate.bgBG,
        accumulatedClosureRate: statistics.accumulatedClosureRate.bgBG,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.bgBG,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.bgBG,
    },
    validation: {
        common: {
            required: 'Това поле е задължително',
            numeric: 'Трябва да е цяло число',
            decimal: 'Трябва да е число',
            positive_interger: 'Трябва да е положително цяло число',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Максимум ${named('number')} цифри`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не може да надвишава ${named('number')} знака`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Превишава максималния брой знаци (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не по-малко от ${named('number')} знака`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Трябва да е точно ${named('number')} знака`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не може да е по-голямо от ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Не може да е по-малко от ${named('number')}`,
            up_to_2_decimal_places: 'Максимум 2 знака след десетичната запетая',
            retain_up: 'Максимум 10 цифри преди десетичната запетая и до 2 след нея',
            retain_ups: 'Максимум 11 цифри преди десетичната запетая и до 4 след нея',
            input_number: 'Моля, въведете арабски цифри',
            only_number_a: 'Само букви или цифри',
            translate: 'Само латински букви',
            positive_integer: 'Моля, попълнете поне едно поле',
            at_least_one: 'Моля, попълнете поне едно',
        },
        tip: {
            incomplete_information: 'Информацията не е попълнена напълно',
        },
    },
    import: {
        template_file: 'Файл с шаблон',
        browse: 'Разглеждане',
        download_template: 'Изтегли шаблон',
        no_file_selected: 'Няма избран файл',
        incorrect_file_type: 'Невалиден тип файл',
        exceed: 'Надвишава',
        upload_success: 'Успешно качване',
        upload_fail: 'Неуспешно качване',
        again_upload:
            'Можете да качвате само изображения във формати jpg, png, bmp или gif. Моля, опитайте отново.',
        attachmentUpload: 'Качване на прикачени файлове',
        otherAttachmentUpload: 'Качване на други прикачени файлове',
        supportedFormats: 'Поддържани формати',
        preview: 'Преглед',
    },
    export: {
        noDataToExport: 'Няма данни за експортиране',
    },
    select: {
        all: 'Всички',
    },
    checkbox: {
        select_all: 'Избери всички',
    },
    dialog: {
        error_message: 'Съобщение за грешка',
        one_year: 'Може да се експортират най-много документи за една година',
    },
    ymd: {
        year: 'година',
        month: 'месец',
        day: 'ден',
        week: 'седмица',
        january: 'януари',
        february: 'февруари',
        march: 'март',
        april: 'април',
        may: 'май',
        june: 'юни',
        july: 'юли',
        august: 'август',
        september: 'септември',
        october: 'октомври',
        november: 'ноември',
        december: 'декември',
    },
};
